var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data),function(item){return _c('info-radio',{key:item.value,attrs:{"current-value":_vm.currentValue,"name":_vm.name,"id":item.id,"value":item.value,"price":item.price,"info":item.info}},[_c('p',[_vm._v(_vm._s(_vm.$t(item.value)))]),_vm._v(" "),(item.text)?_c('p',[_vm._v(_vm._s(_vm.$t(item.text)))]):_vm._e()])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6ec08d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/InfoRadios.vue
// module id = null
// module chunks = 